import { identityApiRef, useApi } from '@backstage/core-plugin-api';
// import { AuthenticationError } from '@backstage/errors';
import {
  ACPermissionResult,
  authorizeReadPermission,
} from '@internal/plugin-access-control-common';
import { useEffect, useState } from 'react';
import useAsyncRetry from 'react-use/lib/useAsyncRetry';

export function usePermission(module) {
  const [aCPermissionResult, setAcPermissionResult] = useState(
    ACPermissionResult.DENY,
  );
  const identityApi = useApi(identityApiRef);
  const { value: credentials } = useAsyncRetry(
    async () => await identityApi.getCredentials(),
  );
  useEffect(() => {
    if (credentials?.token) {
      const { authorizeResult } = authorizeReadPermission(
        credentials?.token,
        module,
      );
      setAcPermissionResult(authorizeResult);
    } else {
      setAcPermissionResult(ACPermissionResult.DENY);
    }
  }, [credentials, module]);

  return aCPermissionResult;
}
